// ── Footer update ────────────────────────────────────────────────────────────

import type { ExtensionContext } from '@earendil-works/pi-coding-agent';
import { StatsCollector } from './collector.js';

export function updateStatsFooter(ctx: ExtensionContext, collector: StatsCollector): void {
  try {
    const line = collector.getFooterData(ctx);
    ctx.ui.setStatus('pi-stats-insight', line);
  } catch (e) {
    // ctx may be stale after /reload — silently ignore
    if (String(e).includes('stale')) return;
    console.error('[pi-stats-insight] footer error:', e);
  }
}